var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFileExcel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669.445,275H825L625,75V225C625,252.616,644.9,275,669.445,275ZM675,325A100,100,0,0,1,575,225V75H175V874.774h0.006c0,0.076-.006.15-0.006,0.226a50,50,0,0,0,50,50H825V325H675ZM400,800H300V750H400v50Zm150,0H450V750H550v50Zm-7.322-282.322L472.856,587.5l69.822,69.822h0a25,25,0,0,1-35.356,35.356h0L437.5,622.856l-69.822,69.822h0a25,25,0,0,1-35.356-35.356h0L402.144,587.5l-69.822-69.822h0a25,25,0,0,1,35.356-35.356h0L437.5,552.145l69.822-69.823h0a25,25,0,0,1,35.356,35.356h0ZM700,800H600V750H700v50Zm0-100H600V650H700v50Zm0-100H600V550H700v50Zm0-100H600V450H700v50Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileExcel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FileExcel.e1421379.svg";
export { ForwardRef as ReactComponent };